/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {Dropdown1} from '../../../../_metronic/partials'
import {useLocation} from 'react-router'
import {useEffect, useState} from 'react'
import {Step1} from '../components/Step1'
import {Step2} from '../components/Step2'
import {Step3} from '../components/Step3'
import axios from 'axios'
import '../../index.css'
export function CreatePrivilege() {
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const [user, setUser] = useState<any>([])
  const [step, setStep] = useState<Number>(1)
  const [idRes, setIDRes] = useState<Number>(1)
  useEffect(
    () => {
      console.log(location)
      setUser(location.state)
    },
    [] // Only re-call effect if value or delay changes
  )
  const getStep = (stepCheck: Number) => {
    let x = ''
    if (step === stepCheck) x = 'active'
    return x
  }

  const nextStep = (stepCheck: Number) => {
    setStep(Number(stepCheck)+1)
  }
  

  const goBack = (stepCheck: Number) => {
    setStep(Number(stepCheck)-1)
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0'>
        <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
              <div className='d-flex flex-column'>
                <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                  <h1>Create Privilege</h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            <li className='nav-item'>
              <span
                className={`nav-link text-active-primary me-6 ` + getStep(1)}
                //to='/crafted/account/overview'
              >
                step 1
              </span>
            </li>
            <li className='nav-item'>
              <span
                className={`nav-link text-active-primary me-6 ` + getStep(2)}
                //to='/crafted/account/settings'
              >
                step 2
              </span>
            </li>
            <li className='nav-item'>
              <span
                className={`nav-link text-active-primary me-6 ` + getStep(3)}
                //to='/crafted/account/settings'
              >
                step 3
              </span>
            </li>
          </ul>
        </div>
      </div>
      {step === 1 ? <Step1 click={nextStep} setdataID={setIDRes} dataID={idRes}/> : null}
      {step === 2 ? <Step2 click={nextStep} clickback={goBack} setdataID={setIDRes} dataID={idRes}/> : null}
      {step === 3 ? <Step3 click={nextStep} clickback={goBack} setdataID={setIDRes} dataID={idRes}/> : null}
      
    </div>
  )
}
